module.exports = __webpack_public_path__ + "img/icon-download.326a9bb6.svg";